import { createLazyResource } from '@magicdoorinc/ui';
import { createMagicDoorContext } from '~/contexts/utils';
import { SubscriptionsRepository } from '~/repositories/subscriptionsRepository';

const repo = new SubscriptionsRepository();

export const [SubscriptionProvider, useSubscription] = createMagicDoorContext('Subscription', () => {
  const [effectiveSubscription, effectiveSubscriptionActions] = createLazyResource(() => repo.getEffectiveSubscription());

  return {
    get effectiveSubscription() {
      effectiveSubscriptionActions.fetch();
      return effectiveSubscription;
    },
  };
});
